<template>
  <div>
    <div class="card-header">
      <i class="fa fa-align-justify"></i> Promotions
      <select v-model="search">
        <option disabled value="">Sort by Catalog</option>
          <option v-for="catalog in fetchCatalogs">{{catalog}}</option>
      </select>
    </div>

    <div class="card-group">
      <div class="card" v-for="promotion in promotionsFilteredList">
        <img class="card-img-top imageinside" :src="promotion.promotions.banner" :alt="promotion.codename">
        <div class="card-body">
          <h6 class="card-title">{{promotion.name}}</h6>
          <p class="card-text">{{promotion.catalog.name}}</p>
          <p class="card-text">
            <small class="text-muted">
              <router-link :to="{ name: 'Promotion', params: {id: promotion.id} }">{{promotion.id}}</router-link>
            </small>
            <img class="icon" :src="promotion.promotions.icon" :alt="promotion.codename" v-if="promotion.promotions.icon">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss">
  .icon {
    float: right;
    width: 50px;
    z-index: 1;
    margin: -30px 0px 0px 0px;
  }
</style>

<script>

import promotions from 'services/promotions'
import LoadingRows from 'components/LoadingRows'

export default {
  name: 'promotions',
  created () {
    this.fetchData()
  },
  data () {
    return {
      promotions: [],
      loading: false,
      search: ''
    }
  },
  computed: {
    promotionsFilteredList () {
      return this.promotions.filter(promotion => {
        return promotion.catalog.name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    fetchCatalogs () {
      var listPromotions = this.promotions.map(function (promotion) {
        return promotion.catalog.name
      })

      return [...new Set(listPromotions)].sort()
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    LoadingRows
  },
  methods: {
    fetchData () {
      promotions.all(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/promotions/Promotions.vue